const print = (str, n) => null;//console.log(" ".repeat(n) + '[inside '+ str +']');
export default print;


// WEBPACK FOOTER //
// ./src/Lib/Functions/Print.js